module.exports = __webpack_public_path__ + "static/media/fondo_imagenes.53761b25.png";